/* eslint no-use-before-define: 0 */

import $ from "jquery";

const previousResult = {
    address: null,
    response: null,
    error: null,
    initialized: false,
};

export default class GeocodeService {
    /**
     * @param {string} address - Geographic address in Finnish language.
     * @returns Promise
     */
    static requestGeocode(address) {
        if (typeof this.initialized === "undefined") {
            this.initialize();
        }

        const deferred = $.Deferred();

        if (previousResult.initialized && address === previousResult.address) {
            if (!previousResult.error) {
                deferred.resolve(previousResult.response);
            } else {
                deferred.reject(previousResult.error);
            }

            return deferred.promise();
        }

        if (this.geocoder) {
            this.geocoder.geocode(createGeocodeParams(address),
                (results, status) => {
                    if (status === "OK") {
                        if (!(results && results.length > 0)) {
                            deferred.resolve({
                                lat: null,
                                lng: null,
                                searchTerm: address,
                                formatted_address: address,
                            });
                        }

                        previousResult.address = address;
                        previousResult.initialized = true;

                        const place = results[0];
                        if (place
                            && place.geometry
                            && place.geometry.location
                            && place.geometry.location.lat
                            && place.geometry.location.lng) {
                            const response = {
                                lat: place.geometry.location.lat(),
                                lng: place.geometry.location.lng(),
                                searchTerm: address,
                                formatted_address: place.formatted_address,
                                address_components: place.address_components,
                            };
                            previousResult.response = response;
                            previousResult.error = null;
                            deferred.resolve(response);
                        }
                    } else {
                        previousResult.response = null;
                        previousResult.error = `Geocode was not successful for the following reason: ${status}`;
                        deferred.reject(previousResult.error);
                    }
                });
        } else {
            deferred.reject("Google Maps Geocode service is not avaliable");
        }

        return deferred.promise();

        /**
         * @returns {Object} - parameters for Google Maps Geocode service
         */
        function createGeocodeParams() {
            return {
                address,
                componentRestrictions: {
                    country: "FI",
                },
                region: "FI",
            };
        }
    }

    static initialize() {
        this.geocoder = typeof window.google !== "undefined" && new window.google.maps.Geocoder();

        this.initialized = true;
    }
}
